import { Trans, useTranslation } from "react-i18next";
import { motion } from "motion/react";
import { ReactComponent as UpgradeProIcon } from "shared/assets/images/icon-upgrade-pro.svg";
import useSubscription, {
  SubscriptionPlan,
} from "shared/hooks/useSubscription";
import { useHistory } from "react-router-dom";
import "./Subscription.scss";

type Props = {
  title?: React.ReactNode;
};

const SubscriptionDefaultCTA: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { eligibleUpgrade, nextUpgrade } = useSubscription();

  const getTitle = () => {
    if (nextUpgrade === SubscriptionPlan.DISTRIBUTION)
      return t("components.Subscription.startDistribution");
    if (nextUpgrade === SubscriptionPlan.LABEL_SERVICES)
      return t("components.Subscription.startLabelServices");

    return t("components.Subscription.startPremium");
  };

  const onClick = () => {
    history.push("/pricing");
  };

  if (!eligibleUpgrade) return null;

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="subscription-default-cta"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (!onClick) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      style={{ height: 38 }}
    >
      <div className="subscription-cta-icon" aria-hidden>
        <UpgradeProIcon />
      </div>
      <div className="subscription-cta-content">
        {title ? (
          title
        ) : (
          <Trans
            i18nKey={getTitle()}
            components={{ span: <span className="cor-destaque" /> }}
          />
        )}
      </div>
      <div className="subscription-cta-content"></div>
    </motion.div>
  );
};

export default SubscriptionDefaultCTA;
